<template>
    <Header title="Política de Privacidade" />
    <div class="flex flex-col gap-2 p-4">
        <h1>Privacy Policy for iLoyal</h1>

        <p>Last Updated: September 2024</p>

        <h2>1. Introduction</h2>

        <p>
            Welcome to iLoyal! This Privacy Policy outlines how we collect, use,
            disclose, and protect the information obtained from users of our
            mobile application. By using iLoyal, you agree to the terms outlined
            in this policy. iLoyal is a cashback points app that allows business
            owners to offer cashback points to their customers.
        </p>

        <h2>2. Information We Collect</h2>

        <h3>2.1 Personal Information:</h3>

        <p>
            We may collect personal information, such as your name, email
            address, phone number, and business details (for business owners)
            when you create an account or customize your experience.
        </p>

        <h3>2.2 Transaction Information:</h3>

        <p>
            iLoyal collects information about transactions, including purchase
            amounts, dates, and cashback points earned or redeemed. This
            information is necessary for the core functionality of the app.
        </p>

        <h3>2.3 Device Information:</h3>

        <p>
            We may collect information about your device, including the device
            type, operating system, and unique device identifiers.
        </p>

        <h3>2.4 Usage Information:</h3>

        <p>
            We collect information about how you use iLoyal, including the
            features you interact with, the duration of use, and any error
            messages.
        </p>

        <h2>3. How We Use Your Information</h2>

        <h3>3.1 Cashback Program Management:</h3>

        <p>
            We use your information to manage the cashback points program,
            including tracking points, processing redemptions, and facilitating
            transactions between businesses and customers.
        </p>

        <h3>3.2 Communication:</h3>

        <p>
            We may use your email address or phone number to send you important
            updates, announcements, and marketing communications. You can
            opt-out of marketing communications at any time.
        </p>

        <h3>3.3 Improvement of Services:</h3>

        <p>
            We analyze user behavior and feedback to enhance and improve the
            functionality and features of iLoyal.
        </p>

        <h2>4. Data Sharing and Disclosure</h2>

        <h3>4.1 Business Partners:</h3>

        <p>
            We share necessary transaction information with participating
            businesses to facilitate the cashback program. This information is
            limited to what is required for program operation.
        </p>

        <h3>4.2 Third-Party Service Providers:</h3>

        <p>
            We may share your information with third-party service providers who
            assist us in providing and improving our services. These providers
            are obligated to protect your information.
        </p>

        <h3>4.3 Legal Requirements:</h3>

        <p>
            We may disclose your information if required to do so by law or in
            response to a valid legal request.
        </p>

        <h2>5. Security</h2>

        <p>
            We employ industry-standard security measures to protect your
            information from unauthorized access, disclosure, alteration, and
            destruction. This includes encryption of sensitive data and regular
            security audits.
        </p>

        <h2>6. Your Choices</h2>

        <p>
            You can manage your communication preferences and opt-out of certain
            data processing activities. However, some features of the app may
            require certain information to function properly.
        </p>

        <h2>7. Children's Privacy</h2>

        <p>
            iLoyal is not intended for children under the age of 13. We do not
            knowingly collect or solicit personal information from children.
        </p>

        <h2>8. Changes to this</h2>
    </div>
</template>
